// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6589":"8b832de7","8172":"19158363"}[chunkId] + ".chunk.css";
};